// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./styles/fonts.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;

}
:root {
    /* colors */
    --color_very_dark_charcoal: #232323;
    --color_dark_charcoal: #4f4f4f;
    --color_very_dark_teal: #00505a;
    --color-white: #ffffff;
    --color-black: #000;
    --color-white-Secondary:  #ffffffbf;
    --color-secondary-100: #fdfaf5;
    --color-offWhite: #FCFCFC;
    --error-orange: #FDA29B;
    --length24: 24px;
    --length64: 64px;
    --length144: 144px;
    
}
input[type=text], input[type=number],input[type=tel], select {
  color: #232323;
  font-size: 16px;
  font-family: "Eina-02";
  font-weight: 400;
  line-height: 24px;
  word-wrap: break-word;
  padding: 16px;
  /* width: 100%; */
  width: 267px;
  border: 0;
}

label {
  /* padding: 12px 12px 12px 0; */
  display: inline-block;
  letter-spacing: -0.25px;
}
.mobile-number-text {
color: var(--color-white-Secondary);
font-size: 18px;
font-family: "Eina-02-bold";
font-weight: 600;
line-height: 27px;
word-wrap: break-word;
padding: 16px 16px 16px 0;
}
.mobile-number {
  font-family: "Eina-02";
  margin-right: 16px;
  margin-bottom: 16px;
}
input[type=submit],
.submit button {
  color: #003036;
  font-size: 16px;
  font-family: "Eina-02-bold";
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
  cursor: pointer;
  background-color:#f0f0f0;
  transition: background-color 0.3s ease;
  padding: 16px 32px;
  border: 0;
  letter-spacing: -0.25px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* input[type=submit]:hover {
  background-color: #068393;
} */
 
.main-container {
  width: 100%;
  height: 100%;
  display: flex;
  background: #004048fa;
}
.left-container, .left-success-container {
  width: 50%;
  height: 100%;
  margin: 0 0 0 auto;
    /* max-width: 860px; */
  
  .header {
    display: flex;
      justify-content: flex-start;
      align-items: center;
      font-size: 34px;
      /* height: 10vh; */
      text-align: center;
      flex-direction: row;
      padding: 40px var(--length144);
      /* max-width: 860px; */
    a{
      display: flex;
      align-items: center;
       
      img{
        display: flex;
        width: 178px;
        /* height: 28.618px; */
        height: auto;
        flex-shrink: 0;
      }
    }
  }
  .hero {
    display: flex;
    margin-bottom: 32px;
    img{
      width: 100%;
      height: auto;
    }
    
  }
  .form-container {
    padding: 32px 80px 0px 144px;
    /* display: flex; */
    justify-content: center;
    align-items: center;
    height: 90%;
  }
  form {
    width: 50vw;
    /* max-width: 640px; */
  }
   .heading {
    width: 100%;
    color: var(--color-white);
    font-size: 48px; 
    font-family: Vesterbro;
    font-weight: 400; 
    line-height: 52px; 
    word-wrap: break-word;
    letter-spacing: -2px;
   }
   .heading-text {
    font-family: "Eina-02-bold";
    width: 100%; 
    color:var(--color-white); 
    font-size: 18px;
    font-weight: 600;
    line-height: 22px; 
    word-wrap: break-word;
    padding: 16px 0px 0px 0px;
   }
   .referral-info{
    color: var(--color-white);
    font-family: "Eina-02";
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    padding: 0 24px 0 24px;
   }
  .referral-subtext {
    font-family: "Eina-02";
    width: 100%; 
    color:var(--color-white-Secondary); 
    font-size: 12px; 
    font-weight: 400;
    line-height: 18px;
    padding: 16px 0 16px 0;
    a {
      color:var(--color-white-Secondary, rgba(255, 255, 255, 0.75));
    }
  }
}
.right-container {
  width: 50%;
  height: 100%;
  background: var(--color-secondary-100);
  .header {
   visibility: hidden;
  }
  .form-container {
    border-radius: 0;
    padding: 128px 144px 64px 80px;
    /* display: flex; */
    justify-content: center;
    align-items: center;
    height: 90%;
  }
  .form-right {
    .heading {
      color: var(--color_very_dark_charcoal, #232323);
    /* Primitive/Title/XL/Regular */
      font-family: Vesterbro;
      font-size: 40px;
      font-style: normal;
      font-weight: 400;
      line-height: 44px; /* 110% */
      letter-spacing: -2px;
    }
    .feature-1 {
      margin: 40px 0;
      .feature-1-img {
        height: 84px;
        padding-bottom: 20px;
        img{
          height: 64px;
          width: 64px;
        }
      }
      .feature-1-heading{
        color: var(--color-black, #000);
        /* Heading S/Regular */
        font-family: Vesterbro;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 28px; /* 116.667% */
        letter-spacing: -1px;
        margin: 20px 0 12px 0;
      }
      .feature-1-text {
        color: var(--color_very_dark_charcoal, #232323);
        /* Meta m/Regular */
        font-family: "Eina-02";
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 24px; /* 24px */
      }
    }
  .rating {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    .rating-star {
      display: flex;
      img {
        width: 234px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
    .rating-fscs{
      display: flex;
      img {
        width: 89.705px;
        height: 77px;
      }
    }
  }

  }
}


.col-25 {
  float: left;
  width: 25%;
}
.col-50 {
  float: left;
  width: 50%;
}
.col-265{
  float: left;
  width: 265px;
}
.col-75 {
  float: left;
  width: 75%;
}
.submit button {
  position: relative;
}
input[type=submit],
.submit button {
  border-radius: 0;
}

input[type=submit]:disabled,
.submit button:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

/* Clear floats after the columns */
.row {
  width: 485px;
  max-width: 485px;
}
.row:after {
  content: "";
  display: table;
  clear: both;
}
.error-message {
  display: block;
color: var(--error-orange, #FDA29B);;
font-size: 16px;
font-family: "Eina-02";
font-weight: 600;
line-height: 24px;
word-wrap: break-word;
margin-top: 24px;
}
.submit {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.submit button .spinner {
  border: 2px solid #003036;
  border-top-color: transparent;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: inline-block;
  animation: button-spin 0.8s linear infinite;
  opacity: 0;
  pointer-events: none;
}

.submit button .button-text {
  pointer-events: none;
}

.submit button.is-loading .spinner {
  opacity: 1;
}

@keyframes button-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
hr {
  display: block;
  height: 1px;
  border: 0;
  border-top: 1px solid #000;
  margin: 0;
  padding: 0;
}
/* .form-left, .form-right, .form-container  {
  max-width: 860px;
}  */

/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */
@media screen and (max-width: 1280px) {
.main-container{
  display: block;
}
.left-container {
  .header {
      padding: 40px var(--length64);
}}
.left-container,.right-container {
  width: 100%;
  .form-container {
    padding: 64px;
  }
}
.tp-widget-wrapper {
  margin: 0 !important;
}

}


@media screen and (max-width: 1024px) {
  .main-container{
    display: block;
  }
  .left-container,.right-container {
    width: 100%;
    .form-container {
      padding: 64px;
    }
  }
  .tp-widget-wrapper {
    margin: 0 !important;
}

}
@media screen and (max-width: 600px) {
   .col-25, .col-75, input[type=submit] {
    width: 100%;
    margin-top: 16px;
  }
  .col-50 {
    width: 100%;
  }
  .col-265{
    width: 100%;
  }
  .row {
    width: auto;
    max-width: auto;
  }
  input[type=text], input[type=number], input[type=tel]{
    border-radius: 0;
    width: 100%;
  }
  .left-container {
    .header {
      display: flex;
      padding: 16px 16px 8px 16px;
      align-items: flex-start;
      gap: 10px;
      align-self: stretch;
      a {
        img {
            display: flex;
            width: 150px;
            height: 20px;
            flex-shrink: 0;
        }
      }

    }
    .hero {
      margin-bottom: 24px;
    }
    .heading {
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 38px;
    letter-spacing: -1px;
  }
  .heading-text {
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    word-wrap: break-word;
    padding: 16px 0px 0px 0px;
}
  form {
    width: 100%;
  }
  }
  .left-container{
    .form-container {
      padding: var(--length24) 16px;
  }
  }
  .mobile-number-text {
    color:var(--color-white-Secondary);
    padding: 16px 0px 16px 0 ;
  }
  .referral-info {
    margin-bottom: 24px;
  }
  .right-container {
    width: 100%;
    .form-container {
      padding: 48px 16px 64px 16px;
    }
    & .form-right {
      .heading {
          font-size: 34px;
          line-height: 38px;
          letter-spacing: -1px;
      }
      .rating {
        display: block;
        .rating-fscs {
          display: flex;
          flex-direction: row;
          justify-content: center;
          margin-bottom: 16px;
          margin-right: 16px;
      }
      
    }
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AACA;EACE,sBAAsB;;AAExB;AACA;IACI,WAAW;IACX,mCAAmC;IACnC,8BAA8B;IAC9B,+BAA+B;IAC/B,sBAAsB;IACtB,mBAAmB;IACnB,mCAAmC;IACnC,8BAA8B;IAC9B,yBAAyB;IACzB,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;;AAEtB;AACA;EACE,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;EACrB,uBAAuB;AACzB;AACA;AACA,mCAAmC;AACnC,eAAe;AACf,2BAA2B;AAC3B,gBAAgB;AAChB,iBAAiB;AACjB,qBAAqB;AACrB,yBAAyB;AACzB;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;EACf,wBAAwB;EACxB,sCAAsC;EACtC,kBAAkB;EAClB,SAAS;EACT,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;IAChB,sBAAsB;;EAExB;IACE,aAAa;MACX,2BAA2B;MAC3B,mBAAmB;MACnB,eAAe;MACf,kBAAkB;MAClB,kBAAkB;MAClB,mBAAmB;MACnB,8BAA8B;MAC9B,sBAAsB;IACxB;MACE,aAAa;MACb,mBAAmB;;MAEnB;QACE,aAAa;QACb,YAAY;QACZ,sBAAsB;QACtB,YAAY;QACZ,cAAc;MAChB;IACF;EACF;EACA;IACE,aAAa;IACb,mBAAmB;IACnB;MACE,WAAW;MACX,YAAY;IACd;;EAEF;EACA;IACE,4BAA4B;IAC5B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE,WAAW;IACX,sBAAsB;EACxB;GACC;IACC,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,oBAAoB;GACrB;GACA;IACC,2BAA2B;IAC3B,WAAW;IACX,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;GAC1B;GACA;IACC,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;GACvB;EACD;IACE,sBAAsB;IACtB,WAAW;IACX,kCAAkC;IAClC,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,sBAAsB;IACtB;MACE,6DAA6D;IAC/D;EACF;AACF;AACA;EACE,UAAU;EACV,YAAY;EACZ,sCAAsC;EACtC;GACC,kBAAkB;EACnB;EACA;IACE,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;EACb;EACA;IACE;MACE,+CAA+C;IACjD,+BAA+B;MAC7B,sBAAsB;MACtB,eAAe;MACf,kBAAkB;MAClB,gBAAgB;MAChB,iBAAiB,EAAE,SAAS;MAC5B,oBAAoB;IACtB;IACA;MACE,cAAc;MACd;QACE,YAAY;QACZ,oBAAoB;QACpB;UACE,YAAY;UACZ,WAAW;QACb;MACF;MACA;QACE,+BAA+B;QAC/B,sBAAsB;QACtB,sBAAsB;QACtB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,aAAa;QAChC,oBAAoB;QACpB,qBAAqB;MACvB;MACA;QACE,+CAA+C;QAC/C,mBAAmB;QACnB,sBAAsB;QACtB,eAAe;QACf,kBAAkB;QAClB,gBAAgB;QAChB,iBAAiB,EAAE,SAAS;MAC9B;IACF;EACF;IACE,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB;MACE,aAAa;MACb;QACE,YAAY;QACZ,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;MACrB;IACF;IACA;MACE,aAAa;MACb;QACE,eAAe;QACf,YAAY;MACd;IACF;EACF;;EAEA;AACF;;;AAGA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;AACd;;AAEA,mCAAmC;AACnC;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;AACb;AACA;EACE,cAAc;AAChB,mCAAmC;AACnC,eAAe;AACf,sBAAsB;AACtB,gBAAgB;AAChB,iBAAiB;AACjB,qBAAqB;AACrB,gBAAgB;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,qBAAqB;EACrB,2CAA2C;EAC3C,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;AACA;EACE,cAAc;EACd,WAAW;EACX,SAAS;EACT,0BAA0B;EAC1B,SAAS;EACT,UAAU;AACZ;AACA;;IAEI;;AAEJ,+IAA+I;AAC/I;AACA;EACE,cAAc;AAChB;AACA;EACE;MACI,6BAA6B;AACnC,CAAC;AACD;EACE,WAAW;EACX;IACE,aAAa;EACf;AACF;AACA;EACE,oBAAoB;AACtB;;AAEA;;;AAGA;EACE;IACE,cAAc;EAChB;EACA;IACE,WAAW;IACX;MACE,aAAa;IACf;EACF;EACA;IACE,oBAAoB;AACxB;;AAEA;AACA;GACG;IACC,WAAW;IACX,gBAAgB;EAClB;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;EACb;EACA;IACE,WAAW;IACX,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,WAAW;EACb;EACA;IACE;MACE,aAAa;MACb,2BAA2B;MAC3B,uBAAuB;MACvB,SAAS;MACT,mBAAmB;MACnB;QACE;YACI,aAAa;YACb,YAAY;YACZ,YAAY;YACZ,cAAc;QAClB;MACF;;IAEF;IACA;MACE,mBAAmB;IACrB;IACA;IACA,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,oBAAoB;EACtB;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;AAC7B;EACE;IACE,WAAW;EACb;EACA;EACA;IACE;MACE,6BAA6B;EACjC;EACA;EACA;IACE,kCAAkC;IAClC,yBAAyB;EAC3B;EACA;IACE,mBAAmB;EACrB;EACA;IACE,WAAW;IACX;MACE,4BAA4B;IAC9B;IACA;MACE;UACI,eAAe;UACf,iBAAiB;UACjB,oBAAoB;MACxB;MACA;QACE,cAAc;QACd;UACE,aAAa;UACb,mBAAmB;UACnB,uBAAuB;UACvB,mBAAmB;UACnB,kBAAkB;MACtB;;IAEF;IACA;EACF;AACF","sourcesContent":["@import \"./styles/fonts.css\";\n* {\n  box-sizing: border-box;\n\n}\n:root {\n    /* colors */\n    --color_very_dark_charcoal: #232323;\n    --color_dark_charcoal: #4f4f4f;\n    --color_very_dark_teal: #00505a;\n    --color-white: #ffffff;\n    --color-black: #000;\n    --color-white-Secondary:  #ffffffbf;\n    --color-secondary-100: #fdfaf5;\n    --color-offWhite: #FCFCFC;\n    --error-orange: #FDA29B;\n    --length24: 24px;\n    --length64: 64px;\n    --length144: 144px;\n    \n}\ninput[type=text], input[type=number],input[type=tel], select {\n  color: #232323;\n  font-size: 16px;\n  font-family: \"Eina-02\";\n  font-weight: 400;\n  line-height: 24px;\n  word-wrap: break-word;\n  padding: 16px;\n  /* width: 100%; */\n  width: 267px;\n  border: 0;\n}\n\nlabel {\n  /* padding: 12px 12px 12px 0; */\n  display: inline-block;\n  letter-spacing: -0.25px;\n}\n.mobile-number-text {\ncolor: var(--color-white-Secondary);\nfont-size: 18px;\nfont-family: \"Eina-02-bold\";\nfont-weight: 600;\nline-height: 27px;\nword-wrap: break-word;\npadding: 16px 16px 16px 0;\n}\n.mobile-number {\n  font-family: \"Eina-02\";\n  margin-right: 16px;\n  margin-bottom: 16px;\n}\ninput[type=submit],\n.submit button {\n  color: #003036;\n  font-size: 16px;\n  font-family: \"Eina-02-bold\";\n  font-weight: 600;\n  line-height: 24px;\n  word-wrap: break-word;\n  cursor: pointer;\n  background-color:#f0f0f0;\n  transition: background-color 0.3s ease;\n  padding: 16px 32px;\n  border: 0;\n  letter-spacing: -0.25px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* input[type=submit]:hover {\n  background-color: #068393;\n} */\n \n.main-container {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  background: #004048fa;\n}\n.left-container, .left-success-container {\n  width: 50%;\n  height: 100%;\n  margin: 0 0 0 auto;\n    /* max-width: 860px; */\n  \n  .header {\n    display: flex;\n      justify-content: flex-start;\n      align-items: center;\n      font-size: 34px;\n      /* height: 10vh; */\n      text-align: center;\n      flex-direction: row;\n      padding: 40px var(--length144);\n      /* max-width: 860px; */\n    a{\n      display: flex;\n      align-items: center;\n       \n      img{\n        display: flex;\n        width: 178px;\n        /* height: 28.618px; */\n        height: auto;\n        flex-shrink: 0;\n      }\n    }\n  }\n  .hero {\n    display: flex;\n    margin-bottom: 32px;\n    img{\n      width: 100%;\n      height: auto;\n    }\n    \n  }\n  .form-container {\n    padding: 32px 80px 0px 144px;\n    /* display: flex; */\n    justify-content: center;\n    align-items: center;\n    height: 90%;\n  }\n  form {\n    width: 50vw;\n    /* max-width: 640px; */\n  }\n   .heading {\n    width: 100%;\n    color: var(--color-white);\n    font-size: 48px; \n    font-family: Vesterbro;\n    font-weight: 400; \n    line-height: 52px; \n    word-wrap: break-word;\n    letter-spacing: -2px;\n   }\n   .heading-text {\n    font-family: \"Eina-02-bold\";\n    width: 100%; \n    color:var(--color-white); \n    font-size: 18px;\n    font-weight: 600;\n    line-height: 22px; \n    word-wrap: break-word;\n    padding: 16px 0px 0px 0px;\n   }\n   .referral-info{\n    color: var(--color-white);\n    font-family: \"Eina-02\";\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n    padding: 0 24px 0 24px;\n   }\n  .referral-subtext {\n    font-family: \"Eina-02\";\n    width: 100%; \n    color:var(--color-white-Secondary); \n    font-size: 12px; \n    font-weight: 400;\n    line-height: 18px;\n    padding: 16px 0 16px 0;\n    a {\n      color:var(--color-white-Secondary, rgba(255, 255, 255, 0.75));\n    }\n  }\n}\n.right-container {\n  width: 50%;\n  height: 100%;\n  background: var(--color-secondary-100);\n  .header {\n   visibility: hidden;\n  }\n  .form-container {\n    border-radius: 0;\n    padding: 128px 144px 64px 80px;\n    /* display: flex; */\n    justify-content: center;\n    align-items: center;\n    height: 90%;\n  }\n  .form-right {\n    .heading {\n      color: var(--color_very_dark_charcoal, #232323);\n    /* Primitive/Title/XL/Regular */\n      font-family: Vesterbro;\n      font-size: 40px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 44px; /* 110% */\n      letter-spacing: -2px;\n    }\n    .feature-1 {\n      margin: 40px 0;\n      .feature-1-img {\n        height: 84px;\n        padding-bottom: 20px;\n        img{\n          height: 64px;\n          width: 64px;\n        }\n      }\n      .feature-1-heading{\n        color: var(--color-black, #000);\n        /* Heading S/Regular */\n        font-family: Vesterbro;\n        font-size: 24px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 28px; /* 116.667% */\n        letter-spacing: -1px;\n        margin: 20px 0 12px 0;\n      }\n      .feature-1-text {\n        color: var(--color_very_dark_charcoal, #232323);\n        /* Meta m/Regular */\n        font-family: \"Eina-02\";\n        font-size: 18px;\n        font-style: normal;\n        font-weight: 400;\n        line-height: 24px; /* 24px */\n      }\n    }\n  .rating {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    .rating-star {\n      display: flex;\n      img {\n        width: 234px;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n      }\n    }\n    .rating-fscs{\n      display: flex;\n      img {\n        width: 89.705px;\n        height: 77px;\n      }\n    }\n  }\n\n  }\n}\n\n\n.col-25 {\n  float: left;\n  width: 25%;\n}\n.col-50 {\n  float: left;\n  width: 50%;\n}\n.col-265{\n  float: left;\n  width: 265px;\n}\n.col-75 {\n  float: left;\n  width: 75%;\n}\n.submit button {\n  position: relative;\n}\ninput[type=submit],\n.submit button {\n  border-radius: 0;\n}\n\ninput[type=submit]:disabled,\n.submit button:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* Clear floats after the columns */\n.row {\n  width: 485px;\n  max-width: 485px;\n}\n.row:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n.error-message {\n  display: block;\ncolor: var(--error-orange, #FDA29B);;\nfont-size: 16px;\nfont-family: \"Eina-02\";\nfont-weight: 600;\nline-height: 24px;\nword-wrap: break-word;\nmargin-top: 24px;\n}\n.submit {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.submit button .spinner {\n  border: 2px solid #003036;\n  border-top-color: transparent;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  display: inline-block;\n  animation: button-spin 0.8s linear infinite;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.submit button .button-text {\n  pointer-events: none;\n}\n\n.submit button.is-loading .spinner {\n  opacity: 1;\n}\n\n@keyframes button-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\nhr {\n  display: block;\n  height: 1px;\n  border: 0;\n  border-top: 1px solid #000;\n  margin: 0;\n  padding: 0;\n}\n/* .form-left, .form-right, .form-container  {\n  max-width: 860px;\n}  */\n\n/* Responsive layout - when the screen is less than 600px wide, make the two columns stack on top of each other instead of next to each other */\n@media screen and (max-width: 1280px) {\n.main-container{\n  display: block;\n}\n.left-container {\n  .header {\n      padding: 40px var(--length64);\n}}\n.left-container,.right-container {\n  width: 100%;\n  .form-container {\n    padding: 64px;\n  }\n}\n.tp-widget-wrapper {\n  margin: 0 !important;\n}\n\n}\n\n\n@media screen and (max-width: 1024px) {\n  .main-container{\n    display: block;\n  }\n  .left-container,.right-container {\n    width: 100%;\n    .form-container {\n      padding: 64px;\n    }\n  }\n  .tp-widget-wrapper {\n    margin: 0 !important;\n}\n\n}\n@media screen and (max-width: 600px) {\n   .col-25, .col-75, input[type=submit] {\n    width: 100%;\n    margin-top: 16px;\n  }\n  .col-50 {\n    width: 100%;\n  }\n  .col-265{\n    width: 100%;\n  }\n  .row {\n    width: auto;\n    max-width: auto;\n  }\n  input[type=text], input[type=number], input[type=tel]{\n    border-radius: 0;\n    width: 100%;\n  }\n  .left-container {\n    .header {\n      display: flex;\n      padding: 16px 16px 8px 16px;\n      align-items: flex-start;\n      gap: 10px;\n      align-self: stretch;\n      a {\n        img {\n            display: flex;\n            width: 150px;\n            height: 20px;\n            flex-shrink: 0;\n        }\n      }\n\n    }\n    .hero {\n      margin-bottom: 24px;\n    }\n    .heading {\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 38px;\n    letter-spacing: -1px;\n  }\n  .heading-text {\n    font-size: 16px;\n    font-weight: 400;\n    line-height: 24px;\n    word-wrap: break-word;\n    padding: 16px 0px 0px 0px;\n}\n  form {\n    width: 100%;\n  }\n  }\n  .left-container{\n    .form-container {\n      padding: var(--length24) 16px;\n  }\n  }\n  .mobile-number-text {\n    color:var(--color-white-Secondary);\n    padding: 16px 0px 16px 0 ;\n  }\n  .referral-info {\n    margin-bottom: 24px;\n  }\n  .right-container {\n    width: 100%;\n    .form-container {\n      padding: 48px 16px 64px 16px;\n    }\n    & .form-right {\n      .heading {\n          font-size: 34px;\n          line-height: 38px;\n          letter-spacing: -1px;\n      }\n      .rating {\n        display: block;\n        .rating-fscs {\n          display: flex;\n          flex-direction: row;\n          justify-content: center;\n          margin-bottom: 16px;\n          margin-right: 16px;\n      }\n      \n    }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
